export default {
  nav: {
    main: 'Galvenais',
    ordersAndInvoices: 'Pasūtījumi un rēķini',
    drafts: 'Melnraksti',
    automation: 'Automatizācija',
    workspace: 'Darba vide',
    templates: 'Veidnes',
    delivery: 'Piegāde',
    settings: 'Iestatījumi',
    shippingLabels: 'Sūtījumu etiķetes',
    subscriptions: 'Abonementi',
    support: 'Atbalsts',
    developer: 'Izstrādātājs',
    writeReview: 'Uzrakstīt atsauksmi',
    supportTicket: 'Atbalsta pieteikums',
    welcomeTour: 'Iepazīšanās tūre',
    administratorConsole: 'Administratora konsole',
    logout: 'Iziet',
  },
  dashboard: {
    pageTitle: 'Pasūtījumi un rēķini',
    pageDescription: 'Manage your orders and invoices',
    title: 'Pasūtījumi un rēķini',
    selectedOrders: '{count} atlasītie pasūtījumi',
    completed: '% pabeigts',
    processing: 'Apstrādā, lūdzu uzgaidiet...',
    bulkDownload: 'Masveida lejupielāde',
    upgradeBulkDownload: 'Uzlabojiet savu plānu masveida lejupielādei',
    showFilters: 'Rādīt filtrus',
    hideFilters: 'Slēpt filtrus',
    creatingInvoices: 'Izveido rēķinus, lūdzu uzgaidiet...',
    bulkCreateInvoices: 'Masveida rēķinu izveide',
    cannotCreateAutopilot: 'Jūs nevarat manuāli izveidot rēķinus, kad rēķinu režīms ir automātiskais.',
    exportInvoices: 'Eksportēt rēķinus vai pasūtījumus',
    capturePayments: 'Manuāli reģistrēt maksājumus',
    filterOrders: 'Filtrēt pasūtījumus',
    error: 'Hmm, kaut kas nogāja greizi...',
    close: 'Aizvērt',
    chooseDate: 'Izvēlieties datumu',
    chooseIssueDate: 'Izvēlieties izsniegšanas datumu atlasītajiem rēķiniem',
    cancel: 'Atcelt',
    createInvoices: 'Izveidot rēķinus',
    storno: 'Storno',
    bulkOrderCapture: 'Masveida pasūtījumu reģistrēšana',
  },
  search: {
    createdBetween: 'Izveidots starp',
    modifiedBetween: 'Mainīts starp',
    orderNumber: 'Pasūtījums #',
    invoiceNumber: 'Rēķins #',
    refundNumber: 'Atmaksa #',
    customer: 'Klients',
    payment: 'Maksājums',
    any: 'Jebkurš',
    authorized: 'Autorizēts',
    pending: 'Gaida',
    paid: 'Apmaksāts',
    partiallyPaid: 'Daļēji apmaksāts',
    refunded: 'Atmaksāts',
    voided: 'Anulēts',
    partiallyRefunded: 'Daļēji atmaksāts',
    unpaid: 'Neapmaksāts',
    fulfillment: 'Izpilde',
    fulfilled: 'Nosūtīts',
    partial: 'Daļējs',
    unfulfilled: 'Nav nosūtīts',
    loading: 'Ielādē pasūtījumus...',
    search: 'Meklēt',
  },
  orderList: {
    noCustomer: 'Nav klienta',
    downloadOrder: 'Lejupielādēt pasūtījumu',
    deleteWarning: 'Svarīgi! Tiks dzēsti visi rēķini un atmaksas, kas izveidoti pēc datuma:',
    includingInvoice: 'ieskaitot atlasīto rēķinu #',
    pressOk: 'Nospiediet OK, lai turpinātu, vai Atcelt, lai pārtrauktu.',
    cannotCreateAutopilot: 'Jūs nevarat manuāli izveidot rēķinus, kad rēķinu režīms ir automātiskais.',
    createInvoice: 'Izveidot rēķinu šim pasūtījumam',
    create: 'Izveidot',
    addCreditNote: 'Pievienot kredītrēķinu',
    createStorno: 'Izveidot storno rēķinu',
    refund: 'Atmaksa',
    downloadInvoice: 'Lejupielādēt šo rēķinu',
    download: 'Lejupielādēt',
    default: 'Noklusējuma',
    downloadStorno: 'Lejupielādēt šo storno/kredītrēķinu',
    fulfillOrder: 'Izpildīt pasūtījumu',
    orderNum: 'Pasūtījums #',
    locPrefix: 'Lok. prefikss',
    invoiceNum: 'Rēķins #',
    refundNum: 'Atmaksa #',
    customerCol: 'Klients',
    orderCreatedDate: 'Pasūtījuma izveides datums',
    orderModifiedDate: 'Pasūtījuma maiņas datums',
    delivered: 'Piegādāts',
    paymentStatus: 'Maksājuma statuss',
    fulfillmentStatus: 'Piegādes statuss',
    totalOutstanding: 'Kopējā nesamaksātā summa',
    originalPrice: 'Sākotnējā cena',
    noOrders: 'Jūsu veikalam nav pasūtījumu ar atlasīto statusu.',
    cannotCreateNoOrders: 'Jūs nevarat izveidot rēķinus, ja nav pasūtījumu.',
    createOrdersFirst: 'Lūdzu, izveidojiet vismaz vienu pasūtījumu un mēģiniet vēlreiz.',
    createOrders: 'Izveidot pasūtījumus',
    loadingOrders: 'Ielādē...',
    paidManual: 'Apmaksāts - Manuāli',
    paid: 'Apmaksāts',
    refunded: 'Atmaksāts',
    pending: 'Gaida',
    partiallyPaid: 'Daļēji apmaksāts',
    partiallyRefunded: 'Daļēji atmaksāts',
    fulfilled: 'Nosūtīts',
    unfulfilled: 'Nav nosūtīts',
    deliveryPending: 'Gaida',
    deliverNow: 'Piegādāt tagad',
    deliveryPartial: 'Daļēja',
    notDelivered: 'Nav piegādāts',
    deliverAgain: 'Piegādāt vēlreiz',
    deliveryDetails: 'Piegādes detaļas',
    deliveryFailed: 'Piegāde neizdevās',
    sent: 'Nosūtīts',
    failed: 'Neizdevās',
    toLabel: 'Kam',
    folderLabel: 'Mape',
    open: 'Atvērts',
    invoice: 'Rēķins',
    creditNote: 'Kredītrēķins',
    stornoLabel: 'Storno',
    unknown: 'Nezināms',
    googleDrive: 'Google Drive',
    clientsTablet: 'Klientu planšete',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-pasts',
    ftpChannel: 'FTP',
    revertToDate: 'Atgriezt uz šo datumu',
    add: 'Pievienot',
    close: 'Aizvērt',
  },
  downloadDialog: {
    downloadType: 'Lejupielādēt {type}...',
    selectTemplate: 'Atlasiet vienu veidni no galerijas, lai eksportētu pasūtījumus, rēķinus, storno rēķinus vai kredītrēķinus.',
    getMoreTemplates: 'Iegūt vairāk veidņu',
    createNewTemplate: 'Izveidot jaunu veidni',
    allCreatedBetween: 'Visi izveidotie {type} starp',
    selectedType: 'Atlasītie {type}',
    and: 'un',
    status: 'Statuss',
    any: 'Jebkurš',
    open: 'Atvērts',
    closed: 'Slēgts',
    cancelled: 'Atcelts',
    paymentStatus: 'Maksājuma statuss',
    fulfillmentStatus: 'Piegādes statuss',
    fulfilled: 'Nosūtīts',
    partial: 'Daļējs',
    unfulfilled: 'Nav nosūtīts',
    authorized: 'Autorizēts',
    pending: 'Gaida',
    paid: 'Apmaksāts',
    partiallyPaid: 'Daļēji apmaksāts',
    refunded: 'Atmaksāts',
    voided: 'Anulēts',
    partiallyRefunded: 'Daļēji atmaksāts',
    unpaid: 'Neapmaksāts',
    format: 'Formāts',
    forLocation: 'Atrašanās vieta',
    advancedOptions: 'Papildu iestatījumi',
    exportHSCodes: 'Eksportēt inventāra HS kodus (lēnāk)',
    noteChrome: 'Piezīme: Optimālai lejupielādei ieteicams Chrome un reklāmu bloķētāja atspējošana.',
    downloadIndividually: 'Lejupielādēt atsevišķi',
    downloadGrouped: 'Lejupielādēt grupēti',
  },
  templates: {
    pageTitle: 'Veidnes',
    pageDescription: 'Customize your invoice templates',
    title: 'Veidnes',
    installTranslated: 'Instalēt tulkotu veidni',
    installTranslatedDesc: 'Izvēlieties citu valodu, noklikšķinot uz šīs pogas.',
    createNew: 'Izveidot jaunu veidni, ja nepieciešams',
    createNewDesc: 'Noklikšķiniet uz šīs pogas, lai izveidotu jaunu veidni, ja nepieciešams.',
    customize: 'Pielāgot veidnes',
    customizeDesc: 'Noklikšķiniet uz noklusējuma veidnes, lai to pielāgotu. Jūs varat mainīt logotipu, krāsas un pieredzējušākiem lietotājiem — kodu.',
    defaultTemplate: 'Rēķins, Storno un Kredītrēķins (Noklusējuma)',
    logo: 'Logotips',
    colorPalette: 'Krāsu palete',
    getColorPalettes: 'Iegūt krāsu paletes',
    paperSize: 'Papīra izmērs',
    format: 'Formāts',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientācija',
    landscape: 'Ainava',
    portrait: 'Portrets',
    margin: 'Piemale (cm)',
    unsavedChanges: 'Nesaglabātas izmaiņas',
    discard: 'Atmest',
    save: 'Saglabāt',
  },
  labels: {
    pageTitle: 'Sūtījumu etiķetes',
    pageDescription: 'Create and manage shipping labels',
    title: 'Sūtījumu etiķetes',
    glsRequiresPro: 'GLS sūtījumu etiķetes EEU valstīm pieprasa Professional plānu.',
    upgradeDesc: 'Uzlabojiet uz Professional, lai izveidotu un pārvaldītu sūtījumu etiķetes.',
    upgradePlan: 'Uzlabojiet savu plānu',
    eeuGls: 'EEU GLS',
    enabled: 'Iespējots',
    country: 'Valsts',
    hungary: 'Ungārija',
    slovakia: 'Slovākija',
    czech: 'Čehija',
    romania: 'Rumānija',
    slovenia: 'Slovēnija',
    croatia: 'Horvātija',
    senderId: 'Sūtītāja ID',
    username: 'Lietotājvārds',
    password: 'Parole',
    name: 'Nosaukums',
    city: 'Pilsēta',
    address: 'Adrese',
    zipCode: 'Pasta indekss',
    contactPerson: 'Kontaktpersona',
    phone: 'Tālrunis',
    email: 'E-pasts',
    glsServices: 'GLS pakalpojumi',
    expressService: 'Ekspress pakalpojums',
    exchangeService: 'Apmaiņas pakalpojums',
    smsService: 'SMS pakalpojums',
    smsText: 'SMS teksts',
    preAdviceService: 'Iepriekšēja paziņojuma pakalpojums',
    unsavedChanges: 'Nesaglabātas izmaiņas',
    discard: 'Atmest',
    save: 'Saglabāt',
  },
  billing: {
    pageTitle: 'Norēķini',
    pageDescription: 'Manage your subscription and billing',
    title: 'Norēķini',
    subscriptionFor: 'Abonementa plāns veikalam',
    currentlySubscribed: 'Jūs pašlaik esat abonējis',
    plan: 'plānu',
    cancelSubscription: 'Atcelt abonementu',
    upgradePlan: 'Uzlabojiet savu plānu',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / mēnesī',
    upgrade: 'Uzlabot',
    includesAllStarter: 'Iekļauj visas Starter funkcijas, kā arī:',
    proFeature1: 'Globālā atbilstības suite: Uz atrašanās vietu balstīti prefiksi un pielāgota secīga numerācija',
    proFeature2: 'Viedā lokalizācija: Automātiski tulkoti e-pasti un lokalizēti PDF pielikumi',
    proFeature3: 'Pilns B2B dokumentu cikls: Proformas, B2B piedāvājumi un kredītrēķini',
    proFeature4: 'B2B grāmatvedības sinhronizācija: 3 decimālzīmju vienību precizitāte un daudzvalūtu attēlojumi',
    proFeature5: 'Automātiskās rezerves kopijas: Automātiski kopējiet rēķinus uz drošu FTP vai Google Drive',
    proFeature6: 'Shopify Flow: Automatizējiet rēķinu ģenerēšanu, piegādi un storno, izmantojot Flow trigerus un darbības',
    proFeature7: 'Uzlabotā AI loģika: Izmantojiet ierīcē esošo AI sarežģītiem nosacījumu izkārtojuma noteikumiem',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X eksporti (Eiropas e-rēķinu atbilstība)',
    proFeature9: 'EPC QR kodi tūlītējiem mobilo POS maksājumiem',
    proFeature10: 'GLS sūtījumu etiķetes EEU valstīm',
    proFeature11: '7 gadu atbilstības nodokļu uzglabāšana',
    currentlyUsing: 'Jūs pašlaik izmantojat mūsu',
    free: 'bezmaksas',
    subscriptionPlan: 'abonementa plānu.',
    monthlyUsage: 'Mēneša izmantošana',
    monthlyGenerated: '{count} / 50 rēķini šomēnes',
    monthlyLimitReached: 'Mēneša limits sasniegts. Uzlabojiet uz Starter neierobežotiem rēķiniem.',
    freePlan: 'Bezmaksas plāns',
    freeToInstall: 'Bezmaksas instalēšana',
    freeFeature1: 'Līdz 50 rēķiniem/pasūtījumiem mēnesī',
    freeFeature2: 'Piekļuve visām 31+ iepriekšdefinētajām veidnēm',
    freeFeature3: 'Pamata AI Copilot',
    freeFeature4: 'Standarta PDF lejupielādes un drukāšana',
    freeFeature5: 'Standarta dokumentu komplekts (Rēķini, Pavadzīmes, Kvītis)',
    freeFeature6: '3 mēnešu droša rēķinu uzglabāšana',
    starterPlan: 'Starter plāns',
    starterPrice: '$9.99 / mēnesī',
    starterPricePerInvoice: '+ 3¢ par katru izveidoto rēķinu',
    subscribe: 'Abonēt',
    starterFeature1: 'Neierobežoti rēķini un pasūtījumi',
    starterFeature2: 'Automātiska PDF piegāde pa e-pastu',
    starterFeature3: 'Pilna piekļuve hibrīdredaktoram un AI Copilot',
    starterFeature4: 'Shopify POS un svītrkodu integrācija',
    starterFeature5: 'Shopify Flow: Trigeri un darbības rēķinu automatizācijai',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X eksporti (E-rēķinu atbilstība)',
    starterFeature7: '1 gada droša rēķinu uzglabāšana',
    proTaxOverrides: 'Pielāgoti nodokļu pārrakstījumi: PVN / GST katram produktam un SKU līmeņa likmes',
    unsavedChanges: 'Nesaglabātas izmaiņas',
    discard: 'Atmest',
    save: 'Saglabāt',
  },
  autopilot: {
    pageTitle: 'Automatizācija',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizācija',
    autoCreate: 'Automātiski izveidot rēķinus',
    disabled: 'Atspējots (Manuāli)',
    whenCreated: 'Kad pasūtījumi tiek izveidoti',
    whenFulfilled: 'Kad pasūtījumi tiek izpildīti',
    whenPaid: 'Kad pasūtījumi tiek apmaksāti',
    autoCreateDesc: 'Rēķini tiks izveidoti datumā, kad pasūtījumi tiek izveidoti, izpildīti vai apmaksāti.',
    autoStorno: 'Automātiski stornēt rēķinus',
    whenCancelled: 'Kad pasūtījumi tiek atcelti vai atmaksāti',
    autoStornoDesc: 'Storno rēķini tiks izveidoti datumā, kad pasūtījumi tiek anulēti/atcelti vai atmaksas tiek izveidotas.',
    cannotAutoFree: 'Automātiska rēķinu izveide nav pieejama ar bezmaksas plānu.',
    upgradePlan: 'Uzlabojiet savu plānu',
    unsavedChanges: 'Nesaglabātas izmaiņas',
    discard: 'Atmest',
    save: 'Saglabāt',
  },
  delivery: {
    pageTitle: 'Piegāde',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Piegāde',
    settings: 'Iestatījumi',
    useOrderNumbers: 'Izmantot pasūtījumu numurus failiem',
    sendIfCountry: 'Sūtīt, ja norēķinu adreses valsts ir',
    countryCodesHint: 'Uzskaitiet visus valstu kodus, atdalot ar semikolu.',
    sendForTags: 'Sūtīt klientiem, kuriem ir kāds no uzskaitītajiem tagiem',
    tagsHint: 'Uzskaitiet visus tagus, atdalot ar semikolu.',
    emailDelivery: 'E-pasta piegāde',
    sendAsPdf: 'Sūtīt rēķinus kā PDF pielikumus klientiem',
    autoSend: 'Automātiski sūtīt, kad rēķins tiek izveidots',
    subject: 'Temats',
    body: 'Saturs',
    xmlAttachments: 'XML pielikumi',
    attachUbl: 'Pievienot UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Pievienot ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Sūtīt testa e-pastu',
    sending: 'Sūta...',
    customSmtp: 'Pielāgots SMTP serveris',
    customSmtpDesc: 'Izmantojiet savu pasta serveri noklusējuma vietā',
    enableSmtp: 'Iespējot pielāgotu SMTP',
    smtpHost: 'SMTP resursdators',
    port: 'Ports',
    useSsl: 'Izmantot SSL/TLS',
    username: 'Lietotājvārds',
    password: 'Parole',
    fromEmail: 'No e-pasta',
    fromName: 'No vārda',
    shopifyLiquid: 'Shopify Liquid veidne',
    pasteInto: 'Ielīmējiet šo savā',
    orderConfirmation: 'pasūtījuma apstiprinājuma veidnē',
    toAddLink: 'lai pievienotu lejupielādes saiti.',
    downloadInvoice: 'Lejupielādēt savu rēķinu',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Sūtīt pieprasījumus uz ClientsTablet, kad rēķini tiek izveidoti',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Sūtīt PDF rēķinus kā muitas dokumentus uz ShippyPro valstīm ārpus ES',
    ftpBackup: 'FTP/SFTP rezerves kopija',
    ftpDesc: 'Automātiski kopēt rēķinus uz jūsu serveri',
    enableFtp: 'Iespējot automātisku FTP rezerves kopiju',
    host: 'Resursdators',
    useSftp: 'Izmantot SFTP (drošs)',
    destinationFolder: 'Mērķa mape',
    xmlFiles: 'XML faili',
    includeUbl: 'Iekļaut UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Iekļaut ZUGFeRD / Factur-X XML',
    testConnection: 'Pārbaudīt savienojumu',
    testing: 'Pārbauda...',
    pro: 'PRO',
    upgradeFtp: 'Uzlabojiet uz Professional, lai automātiski kopētu rēķinus uz jūsu FTP/SFTP serveri.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Automātiski sinhronizēt rēķinus ar jūsu Drive',
    connected: 'Savienots',
    disconnect: 'Atvienot',
    notWorking: 'Nedarbojas? Dodieties uz',
    googlePermissions: 'Google atļaujas',
    removeThenReconnect: 'noņemiet Invoice Browse, pēc tam atkārtoti savienojiet.',
    connectGoogleDrive: 'Savienot Google Drive',
    upgradeGoogleDrive: 'Uzlabojiet uz Professional, lai automātiski sinhronizētu rēķinus ar Google Drive.',
    unsavedChanges: 'Nesaglabātas izmaiņas',
    discard: 'Atmest',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Saglabāt',
  },
  bookkeeping: {
    pageTitle: 'Iestatījumi',
    pageDescription: 'Configure your invoice settings',
    title: 'Iestatījumi',
    owner: 'Īpašnieks',
    email: 'E-pasts',
    phone: 'Tālrunis',
    keepDifferentNumbering: 'Saglabāt atsevišķu rēķinu numerāciju katrai pasūtījumu atrašanās vietai',
    keepDifferentNumberingDisabled: 'Atsevišķa rēķinu numerācija katrai pasūtījumu atrašanās vietai nav pieejama ar jūsu plānu.',
    locationEmailDesc: 'Tas ļauj sūtīt e-pastus un rēķinus, kas tulkoti, pamatojoties uz pasūtījuma atrašanās vietu: krājumu atrašanās vieta, piegādes vai norēķinu adrese',
    upgradePlan: 'Uzlabojiet savu plānu',
    matchingCriteria: 'Atbilstības kritēriji',
    locationId: 'Atrašanās vietas ID',
    shippingCountryCode: 'Piegādes adreses valsts kods',
    billingCountryCode: 'Norēķinu adreses valsts kods',
    matchLocationDesc: 'Saskaņot atrašanās vietu, pamatojoties uz pasūtījuma atrašanās vietas ID, piegādes vai norēķinu adreses valsts kodu.',
    companyInfo: 'Uzņēmuma informācija',
    name: 'Nosaukums',
    website: 'Tīmekļa vietne',
    registrationNumber: 'Reģistrācijas numurs',
    taxId: 'Nodokļu ID',
    addressSection: 'Adrese',
    streetName: 'Ielas nosaukums',
    streetNumber: 'Mājas numurs',
    zip: 'Pasta indekss',
    city: 'Pilsēta',
    region: 'Reģions',
    country: 'Valsts',
    bankingInfo: 'Bankas informācija',
    bankName: 'Bankas nosaukums',
    swift: 'Swift',
    currency: 'Valūta',
    iban: 'IBAN',
    invoicing: 'Rēķinu izrakstīšana',
    decimalPlaces: 'Decimālzīmes',
    invoicesPrefix: 'Rēķinu prefikss',
    currentInvoiceNumber: 'Pašreizējais rēķina numurs',
    creditNotesPrefix: 'Kredītrēķinu prefikss',
    currentCreditNoteNumber: 'Pašreizējais kredītrēķina numurs',
    lastInvoiceDate: 'Pēdējā rēķina datums',
    noInvoicesYet: 'Vēl nav izveidots neviens rēķins.',
    confirmReverting: 'Apstiprināt sistēmas atgriešanu',
    allInvoicesAfter: 'Visi rēķini un to storno, kas izsniegti pēc',
    willBeRemoved: 'tiks dzēsti. Turpināt ar sistēmas atgriešanu?',
    cancel: 'Atcelt',
    revert: 'Atgriezt',
    revertDesc: 'Sistēmas atgriešana izdzēsīs visus rēķinus, kas izveidoti pēc atlasītā datuma.',
    revertToDate: 'Atgriezt uz šo datumu',
    reverting: 'Atgriež sistēmu, lūdzu uzgaidiet...',
    useOrderNumbering: 'Izmantot pasūtījumu numerāciju',
    showVat: 'Rādīt PVN uz rēķiniem',
    overrideTaxes: 'Pārrakstīt nodokļus',
    pricesIncludeTax: 'Cenās iekļauts nodoklis',
    productsTaxRate: 'Produktu nodokļa likme',
    shippingTaxRate: 'Piegādes nodokļa likme',
    skusSeparated: 'SKU, atdalīti ar semikolu',
    skusTaxRate: 'SKU nodokļa likme',
    useOrderDates: 'Izmantot pasūtījumu izveides datumus rēķiniem',
    convertCurrency: 'Konvertēt cenas uz valūtu, kurā klients maksā',
    unsavedChanges: 'Nesaglabātas izmaiņas',
    discard: 'Atmest',
    save: 'Saglabāt',
  },
  drafts: {
    pageTitle: 'Melnraksti',
    pageDescription: 'Manage your draft orders',
    title: 'Melnraksti',
    download: 'Lejupielādēt',
    newDraft: 'Jauns melnraksts',
    exporting: 'Eksportē {status}%...',
    accessNotGranted: 'Piekļuve melnrakstu pasūtījumiem nav piešķirta. Lūdzu',
    reLogin: 'piesakieties atkārtoti',
    toGrantPermissions: 'lai piešķirtu nepieciešamās "Draft Orders" atļaujas.',
    pushFailed: 'Nosūtīšana uz Shopify neizdevās:',
    exportError: 'Eksporta kļūda:',
    confirmDelete: 'Vai tiešām vēlaties dzēst šo melnrakstu?',
    incompleteCustomer: 'Klienta dati ir nepilnīgi:',
    pushWithoutCustomer: 'Melnraksts tiks nosūtīts uz Shopify bez klienta datiem. Turpināt?',
    customerNotInShopify: 'Šis klients vēl neeksistē Shopify.',
    warnings: 'Brīdinājumi:',
    createCustomerAndPush: 'Izveidot klientu Shopify un nosūtīt melnraksta pasūtījumu?',
    downloadTitle: 'Lejupielādēt melnrakstus',
    cancel: 'Atcelt',
  },
  draftEdit: {
    number: "Numurs",
    prefix: "Prefikss",

    newDraft: 'Jauns melnraksts',
    editDraft: 'Rediģēt melnrakstu',
    viewInShopify: 'Skatīt Shopify',
    back: 'Atpakaļ',
    createDraft: 'Izveidot melnrakstu',
    saveChanges: 'Saglabāt izmaiņas',
    documentType: 'Dokumenta veids',
    draftOrder: 'Melnraksta pasūtījums',
    quote: 'Piedāvājums',
    proforma: 'Proforma',
    manualInvoice: 'Manuāls rēķins',
    currency: 'Valūta',
    expiryDate: 'Derīguma termiņš',
    status: 'Statuss',
    draft: 'Melnraksts',
    sent: 'Nosūtīts',
    accepted: 'Pieņemts',
    customer: 'Klients',
    firstName: 'Vārds',
    lastName: 'Uzvārds',
    email: 'E-pasts',
    phone: 'Tālrunis',
    company: 'Uzņēmums',
    taxId: 'Nodokļu ID',
    billingAddress: 'Norēķinu adrese',
    address: 'Adrese',
    aptSuite: 'Dzīvoklis/Birojs',
    city: 'Pilsēta',
    province: 'Novads',
    countryField: 'Valsts',
    zip: 'Pasta indekss',
    shippingAddress: 'Piegādes adrese',
    sameAsBilling: 'Tāda pati kā norēķinu',
    lineItems: 'Rindas pozīcijas',
    shipping: 'Piegāde',
    shippingTitle: 'Nosaukums',
    shippingPlaceholder: 'piem. Standarta piegāde',
    price: 'Cena',
    note: 'Piezīme',
    notePlaceholder: 'Iekšējā piezīme vai ziņojums klientam...',
    summary: 'Kopsavilkums',
    subtotal: 'Starpsumma',
    discounts: 'Atlaides',
    tax: 'Nodoklis',
    total: 'Kopā',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Ievadiet sava veikala adresi',
    loginWith: 'Pieteikties ar',
    createAccount: 'Izveidot jaunu kontu',
    placeholder: 'jusu-veikala-nosaukums',
    shopRequired: 'Veikala nosaukums ir obligāts',
    login: 'Pieteikties',
    shopify: 'Shopify',
    terms: 'Noteikumi un nosacījumi',
    privacy: 'Privātuma politika',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Vai jums patīk Invoice Browse?',
    description: "Jūs esat izveidojis savus pirmos rēķinus! Ja lietotne jums ir noderīga, ātra atsauksme Shopify App Store mums ļoti palīdz.",
    reward: "Kā pateicību mēs atiestatīsim jūsu mēneša izmantošanas skaitītāju uz 0",
    leaveReview: 'Atstāt atsauksmi',
    maybeLater: 'Varbūt vēlāk',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Laipni lūdzam Invoice Browse',
    welcomeContent: 'Ļaujiet man parādīt, kā to izmantot.',
    dashboardTitle: 'Informācijas panelis',
    dashboardContent: 'Ekrāns, kuru redzat, ir galvenais informācijas panelis. Šeit jūs varat atrast visus pasūtījumus un eksportēt tos dažādos dokumentu veidos, piemēram: rēķini, pavadzīmes un citi.',
    automationTitle: 'Atvieglojiet savu dzīvi',
    automationContent: 'Iespējojiet automatizāciju, lai izveidotu rēķinus ikreiz, kad pasūtījumi tiek apmaksāti vai atmaksāti.',
    templatesTitle: 'Pielāgot veidnes',
    templatesContent: 'Ienāciet šeit, lai tulkotu savu veidni, pielāgotu to vai izveidotu jaunu.',
    deliveryTitle: 'Piegāde',
    deliveryContent: 'Konfigurējiet mūsu lietotni, lai automātiski kopētu izveidotos dokumentus uz FTP, Google Drive vai kā e-pasta pielikumus.',
    settingsTitle: 'Iestatījumi',
    settingsContent1: 'Pielāgojiet uzņēmuma tālruņa numuru, e-pastu un citus laukus, kas tiek izmantoti dokumentos.',
    settingsContent2: 'Mainiet dokumentu sākuma numuru vai izdzēsiet dokumentus, kas izveidoti pēc noteikta datuma.',
    settingsContent3: 'Pārrakstiet PVN likmes piegādei un produktiem',
    settingsContent4: 'Mainiet decimālzīmju skaitu skaitļiem',
    reviewTitle: 'Uzrakstīt atsauksmi',
    reviewContent: 'Atbalstiet mūsu komandu, uzrakstot mums labu atsauksmi!',
    tourTitle: 'Iepazīšanās tūre',
    tourContent: 'Hei, jūs varat atvērt šo tūri vēlreiz no šejienes.',
    createDocTitle: 'Izveidojiet savu pirmo dokumentu',
    createDocContent: 'Noklikšķiniet uz pogas Izveidot, lai izveidotu savu pirmo dokumentu.',
    docNumberTitle: 'Dokumenta numurs',
    docNumberContent: 'Pirmajam dokumentam ir piešķirts numurs 1. Ja vēlaties sākt ar citu numuru, to var mainīt Iestatījumos.',
    downloadDocTitle: 'Lejupielādēt dokumentu',
    downloadDocContent: 'Noklikšķiniet uz Lejupielādēt nolaižamās izvēlnes un atlasiet dokumenta veidni, lai eksportētu savu pasūtījumu kā PDF.',
  },
  common: {
    save: 'Saglabāt',
    cancel: 'Atcelt',
    close: 'Aizvērt',
    discard: 'Atmest',
    delete: 'Dzēst',
    edit: 'Rediģēt',
    create: 'Izveidot',
    loading: 'Ielādē...',
    unsavedChanges: 'Nesaglabātas izmaiņas',
    upgradePlan: 'Uzlabojiet savu plānu',
  },
  languageSelector: {
    label: 'Valoda',
    auto: 'Automātiska noteikšana',
  },
  draftList: {
    draftNum: 'Melnraksts #',
    shopifyId: 'Shopify ID',
    type: 'Tips',
    customer: 'Klients',
    total: 'Kopā',
    status: 'Statuss',
    delivered: 'Piegādāts',
    date: 'Datums',
    actions: 'Darbības',
    noCustomer: 'Nav klienta',
    noDrafts: 'Nav atrasti melnraksti vai piedāvājumi.',
    loading: 'Ielādē...',
    download: 'Lejupielādēt',
    default: 'Noklusējuma',
    pending: 'Gaida',
    deliverNow: 'Piegādāt tagad',
    deliveryDetails: 'Piegādes informācija',
    sent: 'Nosūtīts',
    failed: 'Neizdevās',
    deliverAgain: 'Piegādāt vēlreiz',
    partial: 'Daļēji',
    notDelivered: 'Nav piegādāts',
    deliveryFailed: 'Piegāde neizdevās',
    unknown: 'Nezināms',
    edit: 'Rediģēt',
    send: 'Sūtīt',
    pushToShopify: 'Sūtīt uz Shopify',
    complete: 'Pabeigt',
    duplicate: 'Dublēt',
    delete: 'Dzēst',
    quote: 'Piedāvājums',
    proforma: 'Proforma',
    draftOrder: 'Melnraksta pasūtījums',
    manualInvoice: 'Manuāls rēķins',
  },
  draftSearch: {
    createdBtw: 'Izveidots starp',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Klients',
    status: 'Statuss',
    type: 'Tips',
    delivery: 'Piegāde',
    any: 'Visi',
    draft: 'Melnraksts',
    sent: 'Nosūtīts',
    accepted: 'Pieņemts',
    expired: 'Beidzies',
    converted: 'Konvertēts',
    cancelled: 'Atcelts',
    quote: 'Piedāvājums',
    proforma: 'Proforma',
    draftOrder: 'Melnraksta pasūtījums',
    manualInvoice: 'Manuāls rēķins',
    delivered: 'Piegādāts',
    notDelivered: 'Nav piegādāts',
    pending: 'Gaida',
    search: 'Meklēt',
  },
  draftDownload: {
    title: 'Lejupielādēt Melnraksts #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Statuss',
    documentType: 'Tips',
    any: 'Visi',
    draft: 'Melnraksts',
    sent: 'Nosūtīts',
    accepted: 'Pieņemts',
    expired: 'Beidzies',
    converted: 'Konvertēts',
    cancelled: 'Atcelts',
    quote: 'Piedāvājums',
    proforma: 'Proforma',
    draftOrder: 'Melnraksta pasūtījums',
    manualInvoice: 'Manuāls rēķins',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Instalēt jaunu veidni',
    tabStyle: 'Stils',
    tabContent: 'Saturs',
    tabTranslations: 'Tulkojumi',
    tabSettings: 'Iestatījumi',
    tabCode: 'Kods',
    tabCopilot: 'AI Kopilots',
    logo: 'Logotips',
    colorPalette: 'Krāsu palete',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/lv.js